import React, {
  useState,
  useMemo,
  useEffect,
  useCallback,
  useContext,
} from "react";
import {
  Download,
  Receipt,
  IndianRupee,
  ArrowUpRight,
  Calendar,
  AlertCircle,
  RefreshCw,
  BarChart3,
  ChevronDown,
  ChevronRight,
  Calculator,
} from "lucide-react";
import { AppContext } from "../../context/AppContext";
import { simpleGetCall } from "../../api/ApiServices";
import { notifyError } from "../../toaster/notify";
import { Spinner } from "react-bootstrap";
import StoreSelector from "../StoreSelector";

// --- CONFIGURATION ---
const CONFIG = {
  // Toggle this to false when connecting to a real backend in production
  USE_MOCK_DATA: true,
  API_ENDPOINT: "/api/sales/day-wise-report",
  CURRENCY: "INR",
  LOCALE: "en-IN",
};

const filterRestaurantName = (resId = null, storesList = []) => {
  if (resId) {
    const item = storesList?.filter((item) => item.value == resId);

    return item?.[0]?.label;
  }
};

// --- MOCK DATA ---
const MOCK_API_RESPONSE = {
  summary: {
    total_orders: 91,
    total_amount: 39899.47,
    total_discount: 60,
    total_tax: 1773.35,
    total_delivery: 1367.62,
    total_packing: 1291.5,
    total_service_charge: 0,
    total_cash: 34227.37,
    total_online: 5672.1,
    total_net_amount: 39839.47,
    total_waived_off: 0,
    total_round_off: 0,
    total_not_paid: 0,
    total_sales: 39899.47,
    avg_orders: 8.27,
    avg_amount: 3627.22,
  },
  restaurantSalesData: [
    {
      restaurantId: 227,
      restaurantName: "ZAM ZAM CALICUT (KOZHIKODE)",
      dayWiseData: [
        {
          salesDate: "2026-01-01T18:30:00.000Z",
          totalSales: 1001.4,
          orderCount: 1,
          taxTotal: 46,
          discountTotal: 0,
          deliveryAmount: 35.4,
          packingAmount: 0,
          serviceCharge: 0,
          cashAmount: 1001.4,
          onlineAmount: 0,
          netAmount: 1001.4,
          invoiceIds: "1001",
          waivedOff: 0,
          roundOff: 0,
          notPaid: 0,
        },
        {
          salesDate: "2026-01-06T18:30:00.000Z",
          totalSales: 5896.46,
          orderCount: 17,
          taxTotal: 248.5,
          discountTotal: 10,
          deliveryAmount: 320.96,
          packingAmount: 357,
          serviceCharge: 0,
          cashAmount: 5896.46,
          onlineAmount: 0,
          netAmount: 5886.46,
          invoiceIds: "1002-1018",
          waivedOff: 0,
          roundOff: 0,
          notPaid: 0,
        },
        {
          salesDate: "2026-01-07T18:30:00.000Z",
          totalSales: 16436.63,
          orderCount: 42,
          taxTotal: 727.95,
          discountTotal: 20,
          deliveryAmount: 561.68,
          packingAmount: 588,
          serviceCharge: 0,
          cashAmount: 14862.68,
          onlineAmount: 1573.95,
          netAmount: 16416.63,
          invoiceIds: "1019-1060",
          waivedOff: 0,
          roundOff: 0,
          notPaid: 0,
        },
        {
          salesDate: "2026-01-08T18:30:00.000Z",
          totalSales: 4967.6,
          orderCount: 11,
          taxTotal: 217,
          discountTotal: 10,
          deliveryAmount: 200.6,
          packingAmount: 210,
          serviceCharge: 0,
          cashAmount: 4967.6,
          onlineAmount: 0,
          netAmount: 4957.6,
          invoiceIds: "1061-1071",
          waivedOff: 0,
          roundOff: 0,
          notPaid: 0,
        },
        {
          salesDate: "2026-01-11T18:30:00.000Z",
          totalSales: 3776.02,
          orderCount: 4,
          taxTotal: 175.9,
          discountTotal: 10,
          deliveryAmount: 40.12,
          packingAmount: 42,
          serviceCharge: 0,
          cashAmount: 628.12,
          onlineAmount: 3147.9,
          netAmount: 3766.02,
          invoiceIds: "1072-1075",
          waivedOff: 0,
          roundOff: 0,
          notPaid: 0,
        },
        {
          salesDate: "2026-01-12T18:30:00.000Z",
          totalSales: 308.81,
          orderCount: 1,
          taxTotal: 12.75,
          discountTotal: 10,
          deliveryAmount: 20.06,
          packingAmount: 21,
          serviceCharge: 0,
          cashAmount: 308.81,
          onlineAmount: 0,
          netAmount: 298.81,
          invoiceIds: "1076",
          waivedOff: 0,
          roundOff: 0,
          notPaid: 0,
        },
      ],
      sub_total_orders: 76,
      sub_total_amount: 32386.92,
      sub_total_discount: 60,
      sub_total_tax: 1428.1,
      sub_total_delivery: 1178.82,
      sub_total_packing: 1218,
      sub_total_service_charge: 0,
      sub_total_net_amount: 32326.92,
      sub_total_cash: 27665.07,
      sub_total_online: 4721.85,
      sub_total_waived_off: 0,
      sub_total_round_off: 0,
      sub_total_not_paid: 0,
    },
    {
      restaurantId: 239,
      restaurantName: "ZAM ZAM Restaurants YMR",
      dayWiseData: [
        {
          salesDate: "2026-01-05T18:30:00.000Z",
          totalSales: 766.5,
          orderCount: 2,
          taxTotal: 35.5,
          discountTotal: 0,
          deliveryAmount: 0,
          packingAmount: 21,
          serviceCharge: 0,
          cashAmount: 472.5,
          onlineAmount: 294,
          netAmount: 766.5,
          invoiceIds: "2001-2002",
          waivedOff: 0,
          roundOff: 0,
          notPaid: 0,
        },
        {
          salesDate: "2026-01-06T18:30:00.000Z",
          totalSales: 693,
          orderCount: 1,
          taxTotal: 33,
          discountTotal: 0,
          deliveryAmount: 0,
          packingAmount: 0,
          serviceCharge: 0,
          cashAmount: 693,
          onlineAmount: 0,
          netAmount: 693,
          invoiceIds: "2003",
          waivedOff: 0,
          roundOff: 0,
          notPaid: 0,
        },
        {
          salesDate: "2026-01-08T18:30:00.000Z",
          totalSales: 3176.15,
          orderCount: 7,
          taxTotal: 144.25,
          discountTotal: 0,
          deliveryAmount: 94.4,
          packingAmount: 52.5,
          serviceCharge: 0,
          cashAmount: 3176.15,
          onlineAmount: 0,
          netAmount: 3176.15,
          invoiceIds: "2004-2010",
          waivedOff: 0,
          roundOff: 0,
          notPaid: 0,
        },
        {
          salesDate: "2026-01-10T18:30:00.000Z",
          totalSales: 656.25,
          orderCount: 1,
          taxTotal: 31.25,
          discountTotal: 0,
          deliveryAmount: 0,
          packingAmount: 0,
          serviceCharge: 0,
          cashAmount: 0,
          onlineAmount: 656.25,
          netAmount: 656.25,
          invoiceIds: "2011",
          waivedOff: 0,
          roundOff: 0,
          notPaid: 0,
        },
        {
          salesDate: "2026-01-11T18:30:00.000Z",
          totalSales: 2220.65,
          orderCount: 4,
          taxTotal: 101.25,
          discountTotal: 0,
          deliveryAmount: 94.4,
          packingAmount: 0,
          serviceCharge: 0,
          cashAmount: 2220.65,
          onlineAmount: 0,
          netAmount: 2220.65,
          invoiceIds: "2012-2015",
          waivedOff: 0,
          roundOff: 0,
          notPaid: 0,
        },
      ],
      sub_total_orders: 15,
      sub_total_amount: 7512.55,
      sub_total_discount: 0,
      sub_total_tax: 345.25,
      sub_total_delivery: 188.8,
      sub_total_packing: 73.5,
      sub_total_service_charge: 0,
      sub_total_net_amount: 7512.55,
      sub_total_cash: 6562.3,
      sub_total_online: 950.25,
      sub_total_waived_off: 0,
      sub_total_round_off: 0,
      sub_total_not_paid: 0,
    },
  ],
};

// --- API SERVICE ---
const fetchReportData = async () => {
  if (CONFIG.USE_MOCK_DATA) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(MOCK_API_RESPONSE);
      }, 500);
    });
  } else {
    try {
      const response = await fetch(CONFIG.API_ENDPOINT);
      if (!response.ok) throw new Error("Network response was not ok");
      return await response.json();
    } catch (error) {
      console.error("Fetch error:", error);
      throw error;
    }
  }
};

// --- UTILITY FUNCTIONS ---
const formatCurrency = (val) => {
  return new Intl.NumberFormat(CONFIG.LOCALE, {
    style: "currency",
    currency: CONFIG.CURRENCY,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(val);
};

const formatDate = (dateString) => {
  if (!dateString) return "-";

  // Expected format: DD-MM-YYYY
  const [day, month, year] = dateString.split("-");

  const date = new Date(year, month - 1, day); // month is 0-based

  if (isNaN(date)) return "-";

  return date.toLocaleDateString(CONFIG.LOCALE, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// --- STYLES FOR STICKY COLUMNS ---
const stickyColStyle = {
  position: "sticky",
  left: 0,
  zIndex: 10,
  backgroundColor: "inherit",
  boxShadow: "2px 0 5px rgba(0,0,0,0.05)",
  minWidth: "150px",
  maxWidth: "180px",
  borderRight: "1px solid #dee2e6",
};

const stickyHeaderStyle = {
  position: "sticky",
  left: 0,
  zIndex: 20,
  backgroundColor: "#f8f9fa", // table-light color
  boxShadow: "2px 0 5px rgba(0,0,0,0.05)",
  minWidth: "150px",
  borderRight: "1px solid #dee2e6",
};

// --- SUB-COMPONENTS ---

const SummaryCard = React.memo(
  ({ title, value, subValue, icon, colorClass }) => (
    <div className="card h-100 shadow-sm border-0">
      <div className="card-body p-2 d-flex flex-column justify-content-between">
        <div className="d-flex justify-content-between align-items-start mb-1">
          <div>
            <p
              className="text-secondary fw-bold text-uppercase mb-0"
              style={{ fontSize: "10px" }}
            >
              {title}
            </p>
            <h6 className="fw-bold text-dark mb-0 mt-1">{value}</h6>
          </div>
          <div className={`p-1 rounded ${colorClass}`}>{icon}</div>
        </div>
        <p
          className="mb-0 text-secondary fw-medium"
          style={{ fontSize: "9px" }}
        >
          {subValue}
        </p>
      </div>
    </div>
  )
);

// --- MAIN COMPONENT ---

const ZamzamDayWiseSalesReport = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [expandedRestaurants, setExpandedRestaurants] = useState({});
  const {
    sidebar,
    setSidebar,
    Dark,
    setDark,
    selectedStoreID,
     setSelectedStoreID, 
    selectedRestID,
    ApiConfig,
    storesList,
     permissions,
  } = useContext(AppContext);

  // Set default dates to TODAY
  const [filters, setFilters] = useState({
    dateFrom: "",
    dateTo: "",
    restaurant: "All",
    status: "All",
  });

  const [loadingExport, setLoadingExport] = useState(false);

  //   const loadData = useCallback(async () => {
  //     try {
  //       setLoading(true);
  //       setError(null);
  //       const response = await fetchReportData();
  //       setData(response);

  //       if (response?.restaurantSalesData) {
  //         const initialExpanded = response.restaurantSalesData.reduce((acc, curr) => ({
  //           ...acc,
  //           [curr.restaurantId]: true
  //         }), {});
  //         setExpandedRestaurants(initialExpanded);
  //       }

  //       setLoading(false);
  //     } catch (err) {
  //       setError("Failed to load report data.");
  //       setLoading(false);
  //     }
  //   }, []);

  //   useEffect(() => {
  //     loadData();
  //   }, [loadData]);

  const [debouncedFilters, setDebouncedFilters] = useState(filters);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilters(filters);
    }, 500); // 👈 delay (ms)

    return () => clearTimeout(timer);
  }, [filters]);



  const getSalesReport = async () => {
    setLoading(true);

    try {
      const res = await simpleGetCall(
        ` ${ApiConfig?.GET_DAY_WISE_SALES_REPORT}?shop_id=${selectedStoreID}&start_date=${debouncedFilters?.dateFrom}&end_date=${debouncedFilters?.dateTo}`
      );

      const itemlist = res.data;
      if (res.success) {
        setData(itemlist);

      
      } else {
      }
    } catch (err) {
      console.error("Status API Error:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (selectedStoreID) {
      getSalesReport();
    }
  }, [selectedStoreID, debouncedFilters]);

  function downloadExcelFromResponse(response, fileName = "report.xlsx") {
    setLoadingExport(true);
    response.blob().then((blob) => {
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    });

    setLoadingExport(false);
  }

  const getSalesReportExport = async () => {
    setLoadingExport(true);
    if (!selectedStoreID) {
      notifyError("Please select a restaurant");
      setLoadingExport(false);
      return;
    }

    try {
      const response = await fetch(
        ` ${ApiConfig?.GET_DAY_WISE_SALES_REPORT_EXPORT}?shop_id=${selectedStoreID}&start_date=${debouncedFilters?.dateFrom}&end_date=${debouncedFilters?.dateTo}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("Token"),
          },
        }
      );

      if (!response.ok) {
        throw new Error("Download failed");
      }

      downloadExcelFromResponse(response, "reports.xlsx");
    } catch (err) {
      notifyError("Something went wrong");
      console.error("Status API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const toggleRestaurant = (id) => {
    setExpandedRestaurants((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // --- DERIVED STATE ---
  const restaurantsList = useMemo(() => {
    if (!data || !data.restaurantSalesData) return ["All"];
    return ["All", ...data.restaurantSalesData.map((r) => r.restaurantName)];
  }, [data]);

  const filteredData = useMemo(() => {
    if (!data || !data.restaurantSalesData) return [];

    return data.restaurantSalesData.filter((restaurant) => {
      if (
        filters.restaurant !== "All" &&
        restaurant.restaurantName !== filters.restaurant
      ) {
        return false;
      }
      return true;
    });
  }, [data, filters.restaurant]);

  // --- DOWNLOAD FUNCTIONALITY ---
  const downloadCSV = () => {
    if (!filteredData || filteredData.length === 0) return;

    const headers = [
      "Restaurant / Date",
      "Invoice Range",
      "Bills",
      "Gross Amt",
      "Tax",
      "Discount",
      "Net Sales",
      "Delivery",
      "Packing",
      "Service",
      "Round Off",
      "Waived",
      "Cash",
      "Online",
      "Not Paid",
    ];

    const rows = [];
    rows.push(headers.join(","));

    filteredData.forEach((restaurant) => {
      // Restaurant Subtotal Row
      const restRow = [
        `"${restaurant.restaurantName}"`,
        `"-"`,
        restaurant.sub_total_orders,
        restaurant.sub_total_amount.toFixed(2),
        restaurant.sub_total_tax.toFixed(2),
        restaurant.sub_total_discount.toFixed(2),
        restaurant.sub_total_net_amount.toFixed(2),
        restaurant.sub_total_delivery.toFixed(2),
        restaurant.sub_total_packing.toFixed(2),
        restaurant.sub_total_service_charge.toFixed(2),
        restaurant.sub_total_round_off.toFixed(2),
        restaurant.sub_total_waived_off.toFixed(2),
        restaurant.sub_total_cash.toFixed(2),
        restaurant.sub_total_online.toFixed(2),
        restaurant.sub_total_not_paid.toFixed(2),
      ];
      rows.push(restRow.join(","));

      // Detail Rows
      restaurant.dayWiseData.forEach((day) => {
        const dayRow = [
          `"${formatDate(day.salesDate)}"`,
          `"${day.invoiceIds || "-"}"`,
          day.orderCount,
          day.totalSales.toFixed(2),
          day.taxTotal.toFixed(2),
          day.discountTotal.toFixed(2),
          day.netAmount.toFixed(2),
          day.deliveryAmount.toFixed(2),
          day.packingAmount.toFixed(2),
          day.serviceCharge.toFixed(2),
          day.roundOff.toFixed(2),
          day.waivedOff.toFixed(2),
          day.cashAmount.toFixed(2),
          day.onlineAmount.toFixed(2),
          day.notPaid.toFixed(2),
        ];
        rows.push(dayRow.join(","));
      });
    });

    const blob = new Blob([rows.join("\n")], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Sales_Report_${filters.dateFrom}_to_${filters.dateTo}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (loading) {
    return (
      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div className="role-content-main">
          <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
            <div
              className="spinner-border spinner-border-sm text-primary"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div className="role-content-main">
          <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
            <div
              className="alert alert-danger py-2 px-3 d-flex align-items-center gap-2"
              style={{ fontSize: "12px" }}
            >
              <AlertCircle size={16} /> {error}
              <button
                onClick={getSalesReport}
                className="btn btn-sm btn-outline-danger ms-2 py-0 px-2"
                style={{ fontSize: "11px" }}
              >
                Retry
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={sidebar ? "taskMain " : "cx-active taskMain"} id="cx-main">
      <div className="role-content">
        {!selectedStoreID ? (
          <div className="text-center">
            {" "}
            <p>Please select a restaurant</p>{" "}
          </div>
        ) : (
          <div
            className="bg-light min-vh-100 p-1"
            style={{
              fontFamily:
                'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            }}
          >
            <div className="container-fluid px-2">
              {/* Header - Ultra Compact */}
              <div className="card shadow-sm border-0 mb-2">
                <div className="card-body p-2 d-flex justify-content-between align-items-center">
                  <h1 className="h6 fw-bold text-dark mb-0 d-flex align-items-center gap-2">
                    <BarChart3 className="text-primary" size={18} />
                    Day Wise Sales Report
                  </h1>
                        {permissions && permissions["View Day Wise Sales Report"] && (
                              <StoreSelector
                                options={Array.isArray(storesList) ? storesList.map(store => ({
                                  value: store.value,
                                  label: store.label,
                                })) : []}
                                value={selectedStoreID}
                                onChange={(value) => {
                                  setSelectedStoreID(value);
                                  localStorage.setItem("selectedStoreId", value);
                                }}
                              />
                            )}
                  <button
                    onClick={getSalesReportExport}
                    className="btn btn-primary btn-sm d-flex align-items-center gap-1 shadow-sm px-2 py-1"
                    style={{ fontSize: "11px" }}
                    disabled={loadingExport}
                  >
                    <Download size={12} />
                    {loadingExport ? <Spinner size="sm" /> : "Download Excel"}
                  </button>
                </div>
              </div>

              {/* High-Level Summary - Compact */}
              <div className="row g-1 mb-2">
                <div className="col-6 col-md-3">
                  <SummaryCard
                    title="Gross Revenue"
                    value={formatCurrency(data?.summary?.total_amount)}
                    subValue="Before Deductions"
                    icon={<IndianRupee size={16} className="text-success" />}
                    colorClass="bg-success-subtle text-success"
                  />
                </div>
                <div className="col-6 col-md-3">
                  <SummaryCard
                    title="Net Sales"
                    value={formatCurrency(data?.summary?.total_net_amount)}
                    subValue="Revenue - Discount"
                    icon={<Calculator size={16} className="text-primary" />}
                    colorClass="bg-primary-subtle text-primary"
                  />
                </div>
                <div className="col-6 col-md-3">
                  <SummaryCard
                    title="Transactions"
                    value={data?.summary?.total_orders}
                    subValue="Total Bills"
                    icon={<Receipt size={16} className="text-info" />}
                    colorClass="bg-info-subtle text-info"
                  />
                </div>
                <div className="col-6 col-md-3">
                  <SummaryCard
                    title="Discounts"
                    value={formatCurrency(data?.summary?.total_discount)}
                    subValue="Total Waived"
                    icon={<ArrowUpRight size={16} className="text-warning" />}
                    colorClass="bg-warning-subtle text-warning"
                  />
                </div>
              </div>

              {/* Report Content */}
              <div className="card shadow-sm border-0">
                {/* Filters Bar - Compact */}
                <div className="card-header bg-light py-1 px-2 border-bottom">
                  <div className="d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center gap-2">
                    <h2
                      className="mb-0 fw-semibold text-dark text-nowrap"
                      style={{ fontSize: "13px" }}
                    >
                      Detailed Breakdown
                    </h2>

                    <div className="d-flex flex-wrap align-items-center gap-1 w-100 w-md-auto justify-content-end">
                      {/* Date From */}
                      <div
                        className="input-group input-group-sm flex-nowrap"
                        style={{ width: "auto" }}
                      >
                        <span
                          className="input-group-text bg-white text-secondary fw-semibold py-0 px-1"
                          style={{ fontSize: "10px", height: "24px" }}
                        >
                          FROM
                        </span>
                        <input
                          type="date"
                          name="dateFrom"
                          value={filters.dateFrom}
                          onChange={handleFilterChange}
                          className="form-control form-control-sm border-start-0 text-secondary py-0 px-1"
                          style={{
                            fontSize: "11px",
                            width: "90px",
                            height: "24px",
                          }}
                        />
                      </div>

                      {/* Date To */}
                      <div
                        className="input-group input-group-sm flex-nowrap"
                        style={{ width: "auto" }}
                      >
                        <span
                          className="input-group-text bg-white text-secondary fw-semibold py-0 px-1"
                          style={{ fontSize: "10px", height: "24px" }}
                        >
                          TO
                        </span>
                        <input
                          type="date"
                          name="dateTo"
                          value={filters.dateTo}
                          onChange={handleFilterChange}
                          className="form-control form-control-sm border-start-0 text-secondary py-0 px-1"
                          style={{
                            fontSize: "11px",
                            width: "90px",
                            height: "24px",
                          }}
                        />
                      </div>

                      {/* Restaurant Filter */}
                      {/* <select
                      name="restaurant"
                      value={filters.restaurant}
                      onChange={handleFilterChange}
                      className="form-select form-select-sm text-secondary py-0 px-2"
                      style={{
                        width: "auto",
                        fontSize: "11px",
                        height: "24px",
                        minWidth: "110px",
                      }}
                    >
                      {restaurantsList.map((r) => (
                        <option key={r} value={r}>
                          {r === "All" ? "Rest: All" : r}
                        </option>
                      ))}
                    </select> */}

                      {/* Status Filter */}
                      {/* <select
                      name="status"
                      value={filters.status}
                      onChange={handleFilterChange}
                      className="form-select form-select-sm text-secondary py-0 px-2"
                      style={{
                        width: "auto",
                        fontSize: "11px",
                        height: "24px",
                        minWidth: "80px",
                      }}
                    >
                      <option value="All">Stat: All</option>
                      <option value="Paid">Paid</option>
                      <option value="Pending">Pending</option>
                      <option value="Cancelled">Canceled</option>
                    </select> */}
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table
                    className="table table-hover mb-0 align-middle table-sm text-nowrap table-bordered"
                    style={{ fontSize: "11px" }}
                  >
                    <thead className="table-light text-uppercase text-secondary">
                      <tr>
                        <th
                          className="px-2 py-1 text-start"
                          style={stickyHeaderStyle}
                        >
                          Restaurant / Date
                        </th>
                        <th className="px-1 py-1 text-center">Inv Range</th>
                        <th className="px-1 py-1 text-center">Bills</th>
                        <th className="px-1 py-1 text-end">Gross</th>
                        <th className="px-1 py-1 text-end">Tax</th>
                        <th className="px-1 py-1 text-end text-danger">Disc</th>
                        <th className="px-1 py-1 text-end fw-bold bg-light">
                          Net Sales
                        </th>
                        <th className="px-1 py-1 text-end">Deliv</th>
                        <th className="px-1 py-1 text-end">Pack</th>
                        <th className="px-1 py-1 text-end">Serv</th>
                        <th className="px-1 py-1 text-end">R.Off</th>
                        <th className="px-1 py-1 text-end">Waived</th>
                        <th className="px-1 py-1 text-end text-success">
                          Cash
                        </th>
                        <th className="px-1 py-1 text-end text-primary">
                          Online
                        </th>
                        <th className="px-1 py-1 text-end text-danger">
                          Unpaid
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length > 0 ? (
                        filteredData.map((restaurant) => (
                          <React.Fragment key={restaurant.restaurantId}>
                            {/* Restaurant Header Row - Showing Subtotals */}
                            <tr
                              className="table-secondary"
                              onClick={() =>
                                toggleRestaurant(restaurant.restaurantId)
                              }
                              style={{ cursor: "pointer", fontWeight: 600 }}
                            >
                              <td
                                className="px-2 py-1 text-dark d-flex align-items-center gap-1"
                                style={stickyColStyle}
                              >
                                {expandedRestaurants[
                                  restaurant.restaurantId
                                ] ? (
                                  <ChevronDown size={12} />
                                ) : (
                                  <ChevronRight size={12} />
                                )}
                                <span
                                  className="text-truncate"
                                  style={{ maxWidth: "180px" }}
                                  title={restaurant.restaurantName}
                                >
                                  {restaurant.restaurantName}
                                </span>
                              </td>
                              <td className="px-1 py-1 text-center text-muted">
                                -
                              </td>
                              <td className="px-1 py-1 text-center text-dark">
                                {restaurant.sub_total_orders}
                              </td>
                              <td className="px-1 py-1 text-end">
                                {formatCurrency(restaurant.sub_total_amount)}
                              </td>
                              <td className="px-1 py-1 text-end text-muted">
                                {formatCurrency(restaurant.sub_total_tax)}
                              </td>
                              <td className="px-1 py-1 text-end text-danger">
                                -{formatCurrency(restaurant.sub_total_discount)}
                              </td>
                              <td className="px-1 py-1 text-end fw-bold text-dark">
                                {formatCurrency(
                                  restaurant.sub_total_net_amount
                                )}
                              </td>
                              <td className="px-1 py-1 text-end text-muted">
                                {formatCurrency(restaurant.sub_total_delivery)}
                              </td>
                              <td className="px-1 py-1 text-end text-muted">
                                {formatCurrency(restaurant.sub_total_packing)}
                              </td>
                              <td className="px-1 py-1 text-end text-muted">
                                {formatCurrency(
                                  restaurant.sub_total_service_charge
                                )}
                              </td>
                              <td className="px-1 py-1 text-end text-muted">
                                {formatCurrency(restaurant.sub_total_round_off)}
                              </td>
                              <td className="px-1 py-1 text-end text-muted">
                                {formatCurrency(
                                  restaurant.sub_total_waived_off
                                )}
                              </td>
                              <td className="px-1 py-1 text-end text-success">
                                {formatCurrency(restaurant.sub_total_cash)}
                              </td>
                              <td className="px-1 py-1 text-end text-primary">
                                {formatCurrency(restaurant.sub_total_online)}
                              </td>
                              <td className="px-1 py-1 text-end text-danger">
                                {formatCurrency(restaurant.sub_total_not_paid)}
                              </td>
                            </tr>

                            {/* Day Rows */}
                            {expandedRestaurants[restaurant.restaurantId] &&
                              restaurant.dayWiseData.map((day, idx) => (
                                <tr key={idx} className="bg-white">
                                  <td
                                    className="px-2 py-1 text-secondary ps-4 border-start-0"
                                    style={{
                                      ...stickyColStyle,
                                      backgroundColor: "#fff",
                                    }}
                                  >
                                    <div className="d-flex align-items-center gap-1">
                                      <Calendar
                                        size={10}
                                        className="text-muted"
                                      />
                                      {formatDate(day.salesDate)}
                                    </div>
                                  </td>
                                  <td
                                    className="px-1 py-1 text-center text-secondary font-monospace"
                                    style={{ fontSize: "10px" }}
                                  >
                                    {day.invoiceIds || "-"}
                                  </td>
                                  <td className="px-1 py-1 text-center text-dark">
                                    {day.orderCount}
                                  </td>
                                  <td className="px-1 py-1 text-end text-secondary">
                                    {formatCurrency(day.totalSales)}
                                  </td>
                                  <td className="px-1 py-1 text-end text-secondary">
                                    {formatCurrency(day.taxTotal)}
                                  </td>
                                  <td className="px-1 py-1 text-end text-danger">
                                    -{formatCurrency(day.discountTotal)}
                                  </td>
                                  <td className="px-1 py-1 text-end fw-semibold text-dark">
                                    {formatCurrency(day.netAmount)}
                                  </td>
                                  <td className="px-1 py-1 text-end text-secondary">
                                    {formatCurrency(day.deliveryAmount)}
                                  </td>
                                  <td className="px-1 py-1 text-end text-secondary">
                                    {formatCurrency(day.packingAmount)}
                                  </td>
                                  <td className="px-1 py-1 text-end text-secondary">
                                    {formatCurrency(day.serviceCharge)}
                                  </td>
                                  <td className="px-1 py-1 text-end text-secondary">
                                    {formatCurrency(day.roundOff)}
                                  </td>
                                  <td className="px-1 py-1 text-end text-secondary">
                                    {formatCurrency(day.waivedOff)}
                                  </td>
                                  <td className="px-1 py-1 text-end text-success">
                                    {formatCurrency(day.cashAmount)}
                                  </td>
                                  <td className="px-1 py-1 text-end text-primary">
                                    {formatCurrency(day.onlineAmount)}
                                  </td>
                                  <td className="px-1 py-1 text-end text-danger">
                                    {formatCurrency(day.notPaid)}
                                  </td>
                                </tr>
                              ))}
                          </React.Fragment>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="15"
                            className="text-center py-4 text-secondary"
                          >
                            No data found matching your filters.
                          </td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot
                      className="table-dark--- text-nowrap"
                      style={{ fontSize: "11px" }}
                    >
                      <tr>
                        <td
                          colSpan="2"
                          className="px-2 py-2 fw-bold text-uppercase text-end"
                        >
                          Grand Total
                        </td>
                        <td className="px-1 py-2 text-center fw-bold">
                          {data?.summary?.total_orders}
                        </td>
                        <td className="px-1 py-2 text-end fw-bold">
                          {formatCurrency(data?.summary?.total_amount)}
                        </td>
                        <td className="px-1 py-2 text-end fw-bold">
                          {formatCurrency(data?.summary?.total_tax)}
                        </td>
                        <td className="px-1 py-2 text-end fw-bold text-danger-emphasis">
                          -{formatCurrency(data?.summary?.total_discount)}
                        </td>
                        <td className="px-1 py-2 text-end fw-bold fs-6">
                          {formatCurrency(data?.summary?.total_net_amount)}
                        </td>
                        <td className="px-1 py-2 text-end fw-bold">
                          {formatCurrency(data?.summary?.total_delivery)}
                        </td>
                        <td className="px-1 py-2 text-end fw-bold">
                          {formatCurrency(data?.summary?.total_packing)}
                        </td>
                        <td className="px-1 py-2 text-end fw-bold">
                          {formatCurrency(data?.summary?.total_service_charge)}
                        </td>
                        <td className="px-1 py-2 text-end fw-bold">
                          {formatCurrency(data?.summary?.total_round_off)}
                        </td>
                        <td className="px-1 py-2 text-end fw-bold">
                          {formatCurrency(data?.summary?.total_waived_off)}
                        </td>
                        <td className="px-1 py-2 text-end fw-bold text-success-emphasis">
                          {formatCurrency(data?.summary?.total_cash)}
                        </td>
                        <td className="px-1 py-2 text-end fw-bold text-info-emphasis">
                          {formatCurrency(data?.summary?.total_online)}
                        </td>
                        <td className="px-1 py-2 text-end fw-bold text-danger-emphasis">
                          {formatCurrency(data?.summary?.total_not_paid)}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ZamzamDayWiseSalesReport;
